<div class="row" *ngIf="(opportunity | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">Child Customer</label>
                        <customer-dropdown [parentForm]="formGroup" [ctrlName]="'customerCtrl'" [placeholder]="'Enter Code'"
                                           (customerSelected)="onCustomerChange($event, 'customerCtrl')"></customer-dropdown>
                    </div>
                </div>
                <div class="row" *ngIf="(searchCustomer | json) != '{}'">
                    <div class="col">
                        <a target="_blank" [routerLink]="['/customer-detail', searchCustomer.customerCode]" tabindex="-1">{{searchCustomer.customerName}}</a><br />
                        <a target="_blank" [routerLink]="['/customer-detail', searchCustomer.customerCode]" tabindex="-1">{{searchCustomer.customerCode}}</a><br />
                        {{searchCustomer.address1}}<br />
                        {{searchCustomer.cityStateZip}}<br />
                        <i class="fas fa-globe"></i> {{searchCustomer.timeZoneName}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
